import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import styles from '../../../style.js';

class SigningDeviceDialog extends React.Component {
  state = {
    open: false
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.props.onClose();
  };
  handleApprove = () => {
    this.props.handleApprove();
  };

  render() {
    const { pinCode,terminal,certificate } = this.props;

    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          open={this.props.open}
          onClose={this.handleClose}
        >
          <DialogTitle id="responsive-dialog-title"><h4>Cihaz ve Sertifika Bilgileri</h4></DialogTitle>
          <DialogContent>
            {/* <DialogContentText>
              <h4>Süreci iptal etmek istediğinize emin misiniz?</h4>
            </DialogContentText> */}
            <InputLabel id="lblTerminal" style={styles.label}>Cihaz</InputLabel>
            <TextField  sx={styles.textField} id="txtTerminal" name="terminal" value={terminal.text} variant="outlined" disabled/>
            <InputLabel id="lblCertificate" style={styles.label}>Sertifika</InputLabel>
            <TextField  sx={styles.textField} id="txtcCrtificate" name="certificate" value={certificate.text} variant="outlined" disabled/>
            <InputLabel id="lblPinCode" style={styles.label}>Pin Kodu</InputLabel>
            <TextField  sx={styles.textField} type="password" labelId="lblPinCode" id="txtPinCode" name="pinCode" value={pinCode} variant="outlined" onChange={this.props.handleChange}/>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              İptal
            </Button>
            <Button onClick={this.handleApprove} color="primary" autoFocus>
              Tamam
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

SigningDeviceDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired
};

export default withMobileDialog()(SigningDeviceDialog);
